{
  "securitySettings.title": "忠誠組態",
  "securitySettings.menuTab.walletApp": "忠誠錢包",
  "securitySettings.menuTab.apiKey": "API 金鑰",
  "securitySettings.menuTab.rds": "RDS 組態",
  "securitySettings.menuTab.salesData": "銷售資料匯入",
  "securitySettings.menuTab.productCatalog": "產品目錄匯入",
  "securitySettings.menuTab.dataLoad": "資料載入",
  "securitySettings.disabledCreateButton.noSiData": "請確保已完成智慧洞察設定。",
  "securitySettings.error.authentication": "您的使用者名稱或密碼不正確，請再試一次。",
  "securitySettings.error.general.title": "錯誤",
  "securitySettings.error.general.text": "發生錯誤，請再試一次。",
  "securitySettings.warning.smartInsightsLinkText": "智慧洞察",
  "securitySettings.warning.smartInsights": "您必須先完成 {link} 設定，才能夠建立 API 金鑰。",
  "securitySettings.grid.column.admin": "管理員",
  "securitySettings.grid.column.appId": "AppID",
  "securitySettings.grid.column.description": "說明",
  "securitySettings.grid.column.created": "已建立",
  "securitySettings.grid.column.status": "狀態",
  "securitySettings.grid.editTooltip": "編輯",
  "securitySettings.grid.deleteTooltip": "刪除",
  "securitySettings.grid.data.activated": "已啟用",
  "securitySettings.grid.data.deactivated": "已停用",
  "securitySettings.authPopup.accountPasswordField": "帳戶密碼",
  "securitySettings.authPopup.accountPasswordFieldError": "輸入帳戶密碼。",
  "securitySettings.authPopup.footerText": "如果您使用 SSO，請聯絡 SAP Emarsys 支援。",
  "securitySettings.setup.appId.label": "AppID",
  "securitySettings.setup.secretKey.label": "密碼金鑰",
  "securitySettings.setup.apiKey.label": "API 金鑰",
  "securitySettings.setup.description.label": "說明",
  "securitySettings.setup.updateDescription.label": "更新說明",
  "securitySettings.setup.CreateNewSecret.label": "建立密碼金鑰",
  "securitySettings.setup.createNewSecret.popup.title": "建立密碼金鑰",
  "securitySettings.setup.createNewSecret.popup.content": "建立現有 AppID 的密碼金鑰。<strong>建立密碼金鑰後，您的錢包在更新網站程式碼中的新密碼前都為已停用。</strong>請輸入密碼以確認您的身份。",
  "securitySettings.setup.activation.label": "啟用",
  "securitySettings.setup.backButton": "返回",
  "securitySettings.walletApp.notificationLinkText": "AppID/密碼金鑰",
  "securitySettings.walletApp.notificationHelpLinkText": "深入瞭解",
  "securitySettings.walletApp.createButton": "建立 AppID/密碼金鑰",
  "securitySettings.walletApp.createButton.disabledTooltip.notAccountOwner": "僅帳戶所有人可建立 AppID/密碼金鑰。",
  "securitySettings.walletApp.authPopup.create.title": "建立 AppID/密碼金鑰",
  "securitySettings.walletApp.authPopup.create.content": "建立 AppID/密碼金鑰前，請輸入密碼以確認您的身份。",
  "securitySettings.walletApp.authPopup.delete.title": "刪除 AppID/密碼金鑰",
  "securitySettings.walletApp.authPopup.delete.content": "您確定要刪除此 AppID/密碼金鑰嗎？<strong>刪除後，也將停用您的錢包。</strong> <br />請輸入密碼以確認您的身份。",
  "securitySettings.walletApp.statusPopup.activate.title": "啟用錢包",
  "securitySettings.walletApp.statusPopup.activate.content": "請確認您要啟用錢包。啟用錢包後，便會在網站上顯示。",
  "securitySettings.walletApp.statusPopup.deactivate.title": "停用錢包",
  "securitySettings.walletApp.statusPopup.deactivate.content": "請確認您要停用錢包。停用錢包後，便不會在網站上提供。",
  "securitySettings.walletApp.setup.title": "建立 AppID/密碼金鑰",
  "securitySettings.walletApp.setup.createdSuccessfully": "已建立 AppID/密碼金鑰。",
  "securitySettings.walletApp.setup.createdNotification": "請記住您的密碼金鑰，您的密碼金鑰只會顯示這一次。關閉此視窗後，您無法再次存取密碼金鑰而必須產生新密碼金鑰。",
  "securitySettings.walletApp.setup.description.tooltip": "輸入 AppID 的唯一說明。",
  "securitySettings.walletApp.setup.activation.tooltip": "在網站上啟用或停用 AppID 以更新錢包",
  "securitySettings.walletApp.setup.activation.options.activate": "啟用錢包",
  "securitySettings.walletApp.setup.activation.options.deactivate": "停用錢包",
  "securitySettings.walletApp.setup.deleteContact.label": "取消會員",
  "securitySettings.walletApp.setup.deleteContact.tooltip": "如果您要錢包中的 [取消成員] 按鈕刪除會員的所有忠誠報表資料，請選擇此選項。",
  "securitySettings.walletApp.setup.deleteContact.checkboxText": "從報表資料庫刪除所有忠誠資料。",
  "securitySettings.apiKey.notificationLinkText": "忠誠 API",
  "securitySettings.apiKey.notificationHelpLinkText": "深入瞭解",
  "securitySettings.apiKey.notificationMessage": "建立 {link} 端點的 API 金鑰。啟動忠誠計劃後，便會啟用 API 金鑰。如果您使用 SSO，請聯絡 SAP Emarsys 支援以取得 API 金鑰。{helpLink}",
  "securitySettings.apiKey.createButton": "建立 API 金鑰",
  "securitySettings.apiKey.createButton.disabledTooltip.notAccountOwner": "僅帳戶所有人可建立 API 金鑰。",
  "securitySettings.apiKey.createButton.disabledTooltip.maxItems": "您無法同時有超過 {maxItems} 個 API 金鑰。",
  "securitySettings.apiKey.authPopup.create.title": "建立 API 金鑰",
  "securitySettings.apiKey.authPopup.create.content": "若要建立 API 金鑰，請輸入密碼以確認您的身份。",
  "securitySettings.apiKey.authPopup.delete.title": "刪除 API 金鑰",
  "securitySettings.apiKey.authPopup.delete.content": "您確定要刪除此 API 金鑰嗎？<strong>刪除後，也將停用 API 金鑰。</strong> <br />請輸入密碼以確認您的身份。",
  "securitySettings.apiKey.statusPopup.activate.title": "啟用 API 金鑰",
  "securitySettings.apiKey.statusPopup.activate.content": "請確認您要啟用 API 金鑰。<strong>啟用 API 金鑰後，您可使用忠誠 API 端點</strong>。",
  "securitySettings.apiKey.statusPopup.deactivate.title": "停用 API 金鑰",
  "securitySettings.apiKey.statusPopup.deactivate.content": "請確認您要啟用 API 金鑰。<strong>停用 API 金鑰後，便會停用忠誠 API 呼叫<strong>。",
  "securitySettings.apiKey.setup.title": "建立 API 金鑰",
  "securitySettings.apiKey.setup.createdSuccessfully": "已建立 API 金鑰。",
  "securitySettings.apiKey.setup.createdNotification": "請記住您的 API 金鑰，您的 API 金鑰只會顯示這一次。關閉此視窗後，您無法再次存取 API 金鑰而必須產生新 API 金鑰。",
  "securitySettings.apiKey.setup.description.tooltip": "輸入 API 金鑰的唯一說明。",
  "securitySettings.apiKey.setup.activation.tooltip": "停用 API 金鑰後，便無法使用此金鑰呼叫忠誠 API。",
  "securitySettings.apiKey.setup.activation.options.activate": "啟用 API 金鑰",
  "securitySettings.apiKey.setup.activation.options.deactivate": "停用 API 金鑰",
  "securitySettings.apiKey.setup.deleteContact.label": "刪除聯絡人 API",
  "securitySettings.apiKey.setup.deleteContact.tooltip": "如果您要 {link} API 刪除成員的所有忠誠資料，請選擇此選項。",
  "securitySettings.apiKey.setup.deleteContact.tooltipLinkText": "刪除",
  "securitySettings.apiKey.setup.deleteContact.checkboxText": "從報表資料庫刪除成員的所有忠誠資料。",
  "securitySettings.rds.createButton": "建立 RDS 憑證",
  "securitySettings.rds.createButton.disabledTooltip.notAccountOwner": "僅帳戶所有人可建立 RDS 憑證。",
  "securitySettings.rds.createNotificationMessageLinkText": "此處",
  "securitySettings.rds.createNotificationMessage": "在忠誠資料庫中建立 RDS 憑證。與忠誠資料庫連線可讓您建立忠誠區段，深入瞭解如何建立連線和建立忠誠區段範本 {helpLink}。",
  "securitySettings.rds.createdNotificationMessageWithPassword": "RDS 憑證會建立與忠誠資料庫的連線。RDS 可讓您建立忠誠範本區段，深入瞭解如何建立連線和建立忠誠區段範本 {helpLink}。",
  "securitySettings.rds.createdNotificationMessageWithoutPassword": "RDS 憑證會建立與忠誠資料庫的連線。RDS 可讓您建立忠誠範本區段，深入瞭解如何建立連線和建立忠誠區段範本 {helpLink}。如果您忘記密碼，請聯絡 SAP Emarsys 支援。",
  "securitySettings.rds.createdWarningNotification": "請記住您的密碼，您的密碼只會顯示這一次。關閉此視窗後，您無法再次存取密碼而必須聯絡 SAP Emarsys 支援。",
  "securitySettings.rds.fields.databaseName": "資料庫名稱",
  "securitySettings.rds.fields.port": "連接埠",
  "securitySettings.rds.fields.host": "主機",
  "securitySettings.rds.fields.userName": "使用者名稱",
  "securitySettings.rds.fields.password": "密碼",
  "securitySettings.rds.fields.certificate": "CA 憑證",
  "securitySettings.rds.authPopup.create.title": "建立 RDS 憑證",
  "securitySettings.rds.authPopup.create.content": "若要建立 RDS 憑證，請輸入密碼以確認您的身份。",
  "securitySettings.salesData.pageTitle": "銷售資料匯入",
  "securitySettings.salesData.topNotification": "若要啟用忠誠銷售資料匯入，請確保您先在 [管理] -> [智慧洞察設定] -> [購買欄位] 下完成銷售上線，並已將資料成功上傳至 Emarsys。然後，完成此頁面上的組態並啟用匯入。{link}。",
  "securitySettings.salesData.topNotification.linkText": "深入瞭解",
  "securitySettings.salesData.saveButton": "儲存",
  "securitySettings.salesData.selectTheSourceOfSalesData": "選擇銷售資料來源。",
  "securitySettings.salesData.sourceField.label": "銷售資料來源",
  "securitySettings.salesData.sourceField.isRequiredError": "需要銷售資料來源。",
  "securitySettings.salesData.sourceField.shopifyPluginOption": "Shopify Plug-In",
  "securitySettings.salesData.sourceField.shopifyPluginOptionTooltip": "深入瞭解 Plug-In {link}。",
  "securitySettings.salesData.sourceField.shopifyPluginOptionTooltipLinkText": "此處",
  "securitySettings.salesData.sourceField.csvApiOption": "SFTP/API CSV 上傳",
  "securitySettings.salesData.sourceField.csvApiOptionTooltip": "深入瞭解 SFTP/API CSV 上傳和忠誠必要欄位 {link}。",
  "securitySettings.salesData.sourceField.csvApiOptionTooltipLinkText": "此處",
  "securitySettings.salesData.sourceField.streamOnboardingOption": "串流上線",
  "securitySettings.salesData.salesField.label": "忠誠點數的銷售欄位",
  "securitySettings.salesData.salesField.tooltip": "從銷售資料選擇應用於計算點數的欄位。",
  "securitySettings.salesData.salesField.priceOption": "價格",
  "securitySettings.salesData.salesField.originalPriceOption": "f_original_price",
  "securitySettings.salesData.salesField.originalPriceOption.tooltip": "如果您使用多個幣別或銷售資料在欄位市場下包含多個市場名稱，請選擇 f_original_price 欄位。請確保在 [管理] -> [智慧洞察設定] -> [購買欄位] 將欄位 f_original_price 和 s_original_currency 設定為可篩選。{link}。",
  "securitySettings.salesData.salesField.originalPriceOption.tooltipLinkText": "深入瞭解",
  "securitySettings.salesData.marketsField.label": "要匯入至忠誠的市場",
  "securitySettings.salesData.marketsField.tooltip": "市場名稱必須精準拼寫，如同您在市場欄位下的銷售資料中傳送的內文。僅將匯入這些列以進行忠誠計算。請確保在 [管理] -> [智慧洞察設定] -> [購買欄位] 下將欄位 s_market 設定為可篩選。",
  "securitySettings.salesData.marketsField.addMarketButton": "新增市場",
  "securitySettings.salesData.marketsField.isRequiredError": "需要市場",
  "securitySettings.salesData.savedSuccessfully": "已儲存銷售資料設定。",
  "securitySettings.salesData.savedError": "嘗試更新設定時發生錯誤",
  "securitySettings.salesData.duplicatedNameError": "此名稱已在使用中，請選擇其他名稱。",
  "securitySettings.salesData.startDateImport.label": "購買匯入的開始日期",
  "securitySettings.salesData.startDateImport.tooltip": "選擇要匯入資料的購買開始日期。忠誠將根據自此日期起所做的購買來計算點數。您僅可最多選擇 30 天前的日期。",
  "securitySettings.salesData.startDateImport.isRequiredError": "需要購買匯入開始日期",
  "securitySettings.salesData.startTimeImport.label": "銷售匯入的開始時間",
  "securitySettings.salesData.startTimeImport.tooltip": "選擇忠誠應從智慧洞察匯入銷售資料的小時 (CET)。請確保將其排程在 [管理] > [智慧洞察設定] > [進階] 中所指定智慧洞察資料載入後的兩小時。",
  "securitySettings.salesData.activation.label": "啟用",
  "securitySettings.salesData.activation.options.activate": "啟用銷售匯入",
  "securitySettings.salesData.activation.options.deactivate": "停用銷售匯入",
  "securitySettings.salesData.planNotLaunched": "您必須先啟動忠誠計劃，才能設定銷售資料匯入。{link}。",
  "securitySettings.salesData.planNotLaunched.linkText": "深入瞭解",
  "securitySettings.productCatalog.pageTitle": "產品資料匯入",
  "securitySettings.productCatalog.topNotification": "若要啟用忠誠產品銷售資料匯入，請確保您先在 [管理] -> [智慧洞察設定] -> [產品欄位] 下完成銷售上線，並已將資料成功上傳至 Emarsys。然後，完成此頁面上的組態。儲存變更後，便會啟用匯入。{link}。",
  "securitySettings.productCatalog.topNotification.linkText": "深入瞭解",
  "securitySettings.productCatalog.saveButton": "儲存",
  "securitySettings.productCatalog.savedSuccessfully": "已儲存產品匯入資料設定。",
  "securitySettings.productCatalog.savedError": "嘗試更新設定時發生錯誤",
  "securitySettings.productCatalog.categoryPathSeparator.label": "選擇種類路徑分隔符號",
  "securitySettings.productCatalog.categoryPathSeparator.tooltip": "選擇要在上傳至智慧洞察的產品目錄中所使用種類分隔符號，這些分隔符號會用於尋找產品階層中的每個產品。範例：[新系列] > [襯衫] -> [女士襯衫]。",
  "securitySettings.productCatalog.categoryPathSeparator.isRequiredError": "需要種類路徑分隔符號",
  "securitySettings.productCatalog.startTimeImport.label": "產品資料匯入的開始時間",
  "securitySettings.productCatalog.startTimeImport.tooltip": "選擇忠誠應從智慧洞察匯入產品資料的小時 (CET)。請確保將其排程在 [管理] > [智慧洞察設定] > [進階] 中所指定智慧洞察資料載入後的兩小時。",
  "securitySettings.productCatalog.activation.label": "啟用",
  "securitySettings.productCatalog.activation.options.activate": "啟用產品匯入",
  "securitySettings.productCatalog.activation.options.deactivate": "停用產品匯入",
  "securitySettings.dataLoad.topNotification": "載入表格將顯示過去 48 小時的購買和產品目錄資料匯入工作細項。如果您看到無法修正的錯誤，請聯絡 SAP Emarsys 支援。{link}",
  "securitySettings.dataLoad.topNotification.linkText": "深入瞭解。",
  "securitySettings.dataLoad.table.header.refreshButton": "重新整理",
  "securitySettings.dataLoad.table.header.taskType": "工作細項類型",
  "securitySettings.dataLoad.table.header.status": "狀態",
  "securitySettings.dataLoad.table.header.messages": "訊息",
  "securitySettings.dataLoad.table.header.date": "日期",
  "securitySettings.dataLoad.table.header.date.tooltip": "系統會根據帳戶中設定的時區來顯示日期。",
  "securitySettings.dataLoad.table.taskType.dailyPurchaseImport": "每日購買匯入",
  "securitySettings.dataLoad.table.taskType.dailyCatalogImport": "每日目錄匯入",
  "securitySettings.dataLoad.table.taskType.dailyPurchaseCopy": "每日購買複製",
  "securitySettings.dataLoad.table.taskStatus.new": "新增",
  "securitySettings.dataLoad.table.taskStatus.published": "已發佈",
  "securitySettings.dataLoad.table.taskStatus.running": "執行中",
  "securitySettings.dataLoad.table.taskStatus.done": "完成",
  "securitySettings.dataLoad.table.taskStatus.failed": "失敗",
  "securitySettings.dataLoad.table.taskMessage.doneHasResults": "已成功匯入新資料。",
  "securitySettings.dataLoad.table.taskMessage.doneNoResults": "沒有要匯入的新資料。",
  "securitySettings.dataLoad.table.taskMessage.doneCopyPurchase": "已成功複製資料。",
  "securitySettings.dataLoad.table.taskMessage.failedCopyPurchase": "銷售資料無法複製到忠誠，請聯絡支援。",
  "securitySettings.walletApp.notificationMessage": "建立您的忠誠錢包 {link}。各忠誠錢包需要不同憑證。啟動忠誠計劃後錢包即為作用中。若您使用 SSO，請聯絡 SAP Emarsys 支援以取得錢包憑證。{helpLink}"
}
